var ww,wh,ws;

function us() {
    ww = $(window).width();
    wh = $(window).height();
    ws = $(window).scrollTop();
}
function checkResize(){
    us();
    // subcribeTigger();
    // Sliders();
    // shoppingBag();
    ProductDetailsHandleSectionH();
    mobileSubnavFixedinAboutNAccount();
    productPageResize();
}

// function isMobileDevice() {
//    return (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1);
// };


$(function(){
    $(window).resize(checkResize);
    checkResize();

    subcribeTrigger();
    Sliders();
    triggermenuItem();
    mobileMenuSublist();
    handleMenuItem();
    // handleHomepageAboutSilder();
    handleShopindexFilter();
    handleSmoothScroll();
    giftCardDropdown();
    rotateLogoAbout();
    FaqToggleItem();
    FaqCollapse();
    productVariantChange();
    engraveOption();
    AboutAddressCheckbox();
    shoppingBag();
    // handle_asSeenIn();
    initTopbar();

    // if (isMobileDevice()) {
    //     $('.modal').css('display','block');
    //     // $(‘.page--speaker .filter-select’).css(‘display’,‘none’);
    // }



    // mouse tracking
    $('.js-hover-logo').mouseenter(function(){
        $('.logo-hoverWrap--animation').addClass('active');
    });
    $('.js-hover-logo').mouseleave(function(){
        $('.logo-hoverWrap--animation').removeClass('active');
    });

    $(document).on('mousemove', function(e){
        var xPos = e.pageX;
         var yPos = e.pageY;
         // console.log(xPos, yPos);
         $('.logo-hoverWrap--animation').css({
           'top': yPos,
           'left': xPos
         });
    });
    //zoom img
    $('.zoom_img')
    .wrap('<span style="display:inline-block;margin-bottom: 20px;"></span>');
  //   .css('display', 'block')
    // .css('overflow', 'hidden')
    // .css('width', '100%')
    // .css('height', '100%')
    // // .css('margin-bottom', '20px')
  //   .parent()
  //   .zoom();

    // fancybox settings
    if ($('[data-fancybox="gallery"]').length > 0) {
        $('[data-fancybox="gallery"]').fancybox({
            autoStart : false,
            keyboard: false,
            arrows: false,
            buttons: [
            // "zoom",
            //"share",
            // "slideShow",
            //"fullScreen",
            //"download",
            // "thumbs",
            "close"
        ],
        });
    }


    $('.color-choice-Wrap .color-choice-item .color-choice-item-wrapper').click(function(){
        $(this).closest('form').find('.color-choice-item-wrapper').removeClass('active');
        $(this).addClass('active');
    });


    $('.productInfo--materialChoice .material-choice-item-wrapper, .material-choice-item-wrapper').click(function(){
        $(this).siblings('.material-choice-item-wrapper').removeClass('active');
        $(this).addClass('active');
        $(this).find('input[type=radio]').prop("checked", true);
    });

    $(window).scroll(function() {
        checkResize();
        handleMenuItem();

        // nav change color
        var sliderTop = $('.heroSlider-container').outerHeight();
        if (ws > sliderTop){
            $('.nav').addClass('hasbg');
        };
    });

    $('.product--fair_pricing').click(function() {
        let honestMarkupElements = $('.honest-markup');
        let offsetTop = honestMarkupElements.offset().top;
        if (honestMarkupElements.length > 1) {
            // handle multiple elements for desktop and mobile
            // take the offset that is lower in the fold
            let otherOffsetTop = $('.honest-markup:eq(1)').offset().top;
            if (offsetTop < otherOffsetTop) {
                offsetTop = otherOffsetTop;
            }
        }

        $('html, body').animate({
            scrollTop: offsetTop - 80
        }, 500);
    });

    const logoMedia = window.matchMedia('(min-width: 992px)');
    const showLogoCaption = function(el) {
        let caption = el.data('text');
        $('.home_brand--title').text(caption);
        if (logoMedia.matches) {
            $('.hmn-logoItem').removeClass('swiper-slide-active');
            $(el).addClass('swiper-slide-active');
        }
    };

    $('.hmn-logoItem')
        .click(function () { showLogoCaption($(this)) })
        .hover(function () {
            if (logoMedia.matches) {
                showLogoCaption($(this));
            }
        });

    const logoSwiper = new Swiper('.hme-logowrap--container', {
        slidesPerView: 2,
        centeredSlides: true,
        slideToClickedSlide: true,
        breakpoints: {
            768: {
                slidesPerView: 4,
                centeredSlides: true,
            },
            992: {
                slidesPerView: 'auto',
                centeredSlides: false,
            }
        }
    });
    logoSwiper.on('breakpoint', function (swiper, params) {
        if (params.slidesPerView == 'auto') {
            $('.hmn-logoItem').css('width', '');
        }
    })
    logoSwiper.on('slideChange', function (swiper) {
        const slide = swiper.slides[swiper.activeIndex];
        showLogoCaption($(slide));
    })

    // lazy loading background images (product images)
    document.addEventListener('lazybeforeunveil', function(e){
    var bg = e.target.getAttribute('data-bg');
        if(bg){
            e.target.style.backgroundImage = 'url(' + bg + ')';
        }
    });
});

function subcribeTrigger() {
    $('#subscribeClose').click(function(){
        $('.subscb').removeClass('on');
    });

    $('#subscribeTrigger').click(function(){
        $('.subscb').addClass('on');
    });
}

function Sliders(){

    // var mySwiper = new Swiper ('.heroSlider-container', {
    //     loop: true,

    // });

    var mySwiper = new Swiper('.slide-banner', {
        autoHeight: false, //enable auto height
        loop: true,
        spaceBetween: 20,
        speed: 800,
        autoplay: {
            delay: 3000,
            disableOnInteraction: false,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      });


    if (window.innerWidth >= 768) {
        var mySwiper2 = new Swiper ('.hme-collect__container', {
            // Optional parameters
            slidesPerView: 1.5,
            spaceBetween: 25,
            loop: true,
            breakpoints: {
                576: {
                    slidesPerView: 2.5,
                    spaceBetween: 25,
                },
                768: {
                    slidesPerView: 3.5,
                    spaceBetween: 25,
                },
                1024: {
                  slidesPerView: 3.5,
                  spaceBetween: 25,
                },
            },
            mousewheel: {
                forceToAxis: true
            },
            preventClicksPropagation: false,
            preventClicks: false,
            navigation: {
            nextEl: '#home_collection .section--silderNav .swiper-button-next',
            prevEl: '#home_collection .section--silderNav .swiper-button-prev',
        },
        });
    } else {
        $(".hme-collect.hme-collect__container .hme-collect__slider").addClass('row');
        $(".hme-collect.hme-collect__container .hme-collect__slider > .swiper-slide").addClass('col-6');
        $(".hme-collect.hme-collect__container .sub-heading.v2-sub-heading").addClass("mb-3 mt-1");
    }

        const homeTrendingEls = document.querySelectorAll('.home_trending-collect__container');
        homeTrendingEls.forEach((el) => {
            const section = el.closest('.section');
            const scrollbar = section.classList.contains('with-scrollbar');
            const withAtc = section.classList.contains('with-atc');
            var homeTrendingSwiper = new Swiper (el, {
                // Optional parameters
                slidesPerView: 1.5,
                spaceBetween: 25,
                loop: !scrollbar && !withAtc,
                nested: true,
                breakpoints: {
                   768: {
                     slidesPerView: 3,
                     spaceBetween: 25,
                   },
                   1024: {
                     slidesPerView: 4,
                     spaceBetween: 25,
                   },
                },
                mousewheel: {
                    forceToAxis: true
                },
                navigation: {
                    nextEl: section.querySelector('.swiper-button-next'),
                    prevEl: section.querySelector('.swiper-button-prev'),
                },
                scrollbar: {
                    el: section.querySelector('.swiper-scrollbar'),
                    draggable: true,
                },
            });
        });

    var mySwiper3 = new Swiper ('.hme-abtnyssa--container', {
        loop: true,
        speed: 800,
         effect: 'fade',
         autoplay: {
           delay: 3500,
           disableOnInteraction: false,
         },
        preventClicksPropagation:false,
        // If we need pagination
        paginationType: "custom",
        pagination: {
            clickable: true,
            el: '.swiper-pagination.hme-abtnyssa__pagination',
        },
        // navigation: {
        //      nextEl: '.swiper-button-next',
        //      prevEl: '.swiper-button-prev',
        // },
    });

    var aboutExploreSwiper = new Swiper ('.about-explore--items__m', {
        // Optional parameters
        slidesPerView: 1.5,
        spaceBetween: 25,
        // loop: true,
        breakpoints: {
           768: {
             slidesPerView: 3,
             spaceBetween: 25,
           },
        },
    });

    var productRecommendationsSwiper = new Swiper ('.relatedItem-swiper', {
        // Optional parameters
        slidesPerView: 2,
        spaceBetween: 30,
        breakpoints: {
           768: {
             slidesPerView: 4,
             spaceBetween: 30,
             allowTouchMove: false
           },
        },
        mousewheel: {
            forceToAxis: true,
        },
        navigation: {
      },
    });

    if (window.innerWidth < 768 && $(".list-featured-articles-slider .blog-card--secondary").length > 2) {
        $('.list-featured-articles > .row').removeClass("row").addClass('d-flex flex-wrap');
        $(".list-featured-articles-slider .blog-card--secondary").removeClass('col-6 col-lg-4 px-lg-2');
        new Swiper('.list-featured-articles-slider', {
            slidesPerView: 2.5,
            spaceBetween: 10,
            mousewheel: false
        });
    } else {
        $(".list-featured-articles-slider .blog-card--secondary.swiper-slide").removeClass('swiper-slide');
    }

    if (window.innerWidth >= 768) {
        var blogCollectionSwiper = new Swiper ('.blog-collection-swiper', {
            // Optional parameters
            slidesPerView: 2,
            spaceBetween: 10,
            breakpoints: {
               768: {
                 slidesPerView: 4,
                 spaceBetween: 10,
                 allowTouchMove: true
               },
            },
            mousewheel: false,
            navigation: {
                nextEl: '.article-product-list .swiper-button-next',
                prevEl: '.article-product-list .swiper-button-prev',
             },
        });
    } else {
        $('.blog-collection-swiper .swiper-wrapper').removeClass('swiper-wrapper').addClass('row');
        var lists = $('.blog-collection-swiper .main-item');
        $('.blog-collection-swiper .row').removeClass('row').addClass('d-flex flex-wrap');
        lists.addClass('col-6 px-1');
        lists.find('.product--infoWrap').addClass('mx-0');
        lists.each((i, el) => {
            if (i > 3) {
                $(el).addClass('d-none');
            }
        });

        $('.blog-collection-swiper .see-more').on('click', function () {
            console.log('clicked');
            $('.main-item.d-none').each((i,el) => {
                if (i < 4) {
                    $(el).removeClass('d-none');
                }
            });
            if (!$('.blog-collection-swiper .main-item.d-none').length) {
                $('.see-more').parent().removeClass('d-block').addClass('d-none');
            }
        });
    }

    var blogTopArticlesSwiper = new Swiper ('.top-articles-mobile', {
      pagination: {
        el: '.swiper-pagination',
      },
      navigation: {
        nextEl: '.top-articles-mobile .swiper-button-next',
        prevEl: '.top-articles-mobile .swiper-button-prev',
      },
    });

  var pdpSwiper = new Swiper(".pdp-sb-container-mobile", {
    effect: "coverflow",
    initialSlide: 1,
    grabCursor: true,
    centeredSlides: true,
    slidesPerView: "auto",
    loop: true,
    coverflowEffect: {
      rotate: 0,
      stretch: 0,
      depth: 100,
      modifier: 1,
      slideShadows: false
    }
  });

var homeSwiper = new Swiper("#home_squares .home-sb-container", {
    effect: "coverflow",
    initialSlide: 1,
    grabCursor: true,
    centeredSlides: true,
    slidesPerView: "auto",
    loop: true,
    mousewheel: {
        forceToAxis: true
    },
    coverflowEffect: {
      rotate: 0,
      stretch: 0,
      depth: 240,
      modifier: 1,
      slideShadows: false
    }
  });

var homeBannerSwiper = new Swiper("#home_banner_carousel .swiper-container", {
    speed: 600,
    effect: 'fade',
    fadeEffect: {
        crossFade: true
    },
    slidesPerView: 1,
    loop: true,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
    },
  });

var homeWhosWearingSwiper = new Swiper("#home_whos_wearing .swiper-container", {
    initialSlide: 1,
    slidesPerView: 1.2,
    spaceBetween: 20,
    breakpoints: {
        768: {
            slidesPerView: 3,
            spaceBetween: 30,
        },
        992: {
            slidesPerView: 3,
            spaceBetween: 40,
        },
    },
  });

var homeBlogSwiper = new Swiper(".home-blog-container:not(.home-blog-container-v2)", {
    slidesPerView: 1.1,
    spaceBetween: 20,
    mousewheel: {
        forceToAxis: true
    },
    preventClicksPropagation: false,
    preventClicks: false,
    breakpoints: {
        768: {
            slidesPerView: 1.8,
        },
    },
    navigation: {
        nextEl: '#home_blog .swiper-button-next',
        prevEl: '#home_blog .swiper-button-prev',
        },
});
window.homeBlogSwiper = homeBlogSwiper;

var homeReviewsSwiper = new Swiper(".home-reviews-container", {
        slidesPerView: 1,
        spaceBetween: 20,
        speed: 1500,
        autoplay: {
           delay: 3500,
           disableOnInteraction: false,
        },
        mousewheel: {
            forceToAxis: true
        },
        preventClicksPropagation: false,
        preventClicks: false,
        navigation: {
            nextEl: '.home-reviews-container .swiper-button-next',
            prevEl: '.home-reviews-container .swiper-button-prev',
        },
        scrollbar: {
            el: '.home-reviews-container .swiper-scrollbar',
            draggable: true,
        },
        breakpoints: {
            768: {
                slidesPerView: 2,
                spaceBetween: 20,
            },
        },
    });
window.homeReviewsSwiper = homeReviewsSwiper;

const colabCollectionSwiper = new Swiper(".section-colab-collection .swiper-container", {
    initialSlide: 0,
    slidesPerView: 1.2,
    spaceBetween: 20,
    breakpoints: {
        768: {
            slidesPerView: 3,
            spaceBetween: 30,
            disable: true,
        },
        992: {
            slidesPerView: 3,
            spaceBetween: 40,
            disable: true,
        },
    },
  });
}

window.Sliders = Sliders;

var galleryThumbs, mobileProductSilder;
function prodPageSilder() {
    galleryThumbs = new Swiper('.thumnails--container ', {
        direction: 'vertical',
        spaceBetween: 15,
        slidesPerView: 'auto',
    });

    mobileProductSilder = new Swiper('#m-pImg-container--swiper', {
        autoHeight: false,
        cssMode: false,
        pagination: {
            el: '.swiper-pagination',
            type: 'custom',
            clickable: true,
            renderCustom: function (swiper, current, total) {
                // console.log('current', current);
                var out = ''
                for (i = 1; i < total+1; i++) {
                  if (i == current) {
                    out = out + '<span class="swiper-pagination-bullet swiper-pagination-bullet-active" tabindex='+i+' role="button" aria-label="Go to slide '+i+1+'"></span>';
                  }
                  else {
                    out = out + '<span class="swiper-pagination-bullet" tabindex='+i+' role="button" aria-label="Go to slide '+i+1+'"></span>';
                  }
                };
                return out;
            },
        },
        // navigation: {
        //     nextEl: '.swiper-button-next',
        //     prevEl: '.swiper-button-prev',
        // },
    });
}
prodPageSilder();

function triggermenuItem(){
    $('.js-search').click(function(){
        $(this).addClass('is-active');
        $('.navSearch--wrapper').addClass('is-active');
        $('html').addClass('search-open');
        setTimeout(function() {
            $('#SearchInput').focus();
        }, 200);

    });

    $('.navSearch--wrapper button.icon-close').click(function(){
        $('.navSearch--wrapper').removeClass('is-active');
        $('.js-search').removeClass('is-active');
    });

    $('.js-navItem.hasdd').mouseenter(function(){
        if($('.navSearch--wrapper').hasClass('is-active')){
        $('.navSearch--wrapper').removeClass('is-active');
        $('.js-search').removeClass('is-active');
        };
    });
    $('#mobile-search-wrapper').on('shown.bs.modal', function () {
        $('#mobileInput').trigger('focus')
    });

    $('.m-hero-menu__close').click(function() {
        $('.m-menu-wrapper').click();
    });

    $('.m-menu-wrapper').click(function(){
        $('.hamburger-menu').toggleClass('open');
        if ($('.m-hero-menu').hasClass('show')) {
            $('.m-menu_best-seller__container').addClass('d-none');
        }
        $('.m-hero-menu').toggleClass('show');
        $('body').toggleClass('no-scroll');
        $('.m-nav-shop, .m-nav-currency').toggleClass('d-none');
    });

    if($('.search__resultHead').length > 0){
        $('.search__wrapper button.icon-close').click(function(){
            $('.search__wrapper').addClass('is-close');
        });
    };
}

function handleMenuItem() {
    // $('.nav').removeClass('hasbg');
    $('.nav--item.hasdd').mouseenter(function(){
        $(this).children('.sublist').addClass('is-active', 500);
    });
    $('.nav--item.hasdd').mouseleave(function(){
        $(this).children('.sublist').removeClass('is-active', 500);
    });
    if($('.hero-banner').length > 0){
        if(ws > 35){
            $('nav.nav').addClass('fixed');
            // $('body').addClass('on-scroll');
            $('.main-nav').addClass('fixed');


        } else{
            $('nav.nav').removeClass('fixed');
            $('body').removeClass('on-scroll');
            $('.main-nav').removeClass('fixed');
            // $('.nav').removeClass('hasbg');
        }

        var silderH = $('.heroSlider-container').outerHeight() + $('.heroSlider-container').offset().top;
        // console.log(silderH);
        if (ws <= silderH) {
            $('.nav').mouseover(function(){
                $('.nav').addClass('hasbg');
            });
            $('.nav').mouseleave(function(){
                // $('.nav').removeClass('hasbg');
            });
        }
    }
    if (ws > 35){
        $('nav.nav').addClass('fixed');
        // $('body').addClass('on-scroll');
        $('.main-nav').addClass('fixed');
        $('.navSearch--wrapper').addClass('fixed');

    } else {
        $('nav.nav').removeClass('fixed');
        $('body').removeClass('on-scroll');
        $('.main-nav').removeClass('fixed');
        $('.navSearch--wrapper').removeClass('fixed');
        // $('.nav').removeClass('hasbg');
    };

    // mobile menu
    if(ws > 25){
        $('.m-menu').addClass('fixed');
        $('.m-hero-menu').css('top','60px');
        $('.m-hero-menu').css('height', 'calc(100% - 60px)');

    } else {
        $('.m-menu').removeClass('fixed');
        $('.m-hero-menu').css('top','115px');
        $('.m-hero-menu').css('height', 'calc(100% - 115px)');
    }
}

function mobileMenuSublist(){
    $(".m-menu--header > div").click(function() {
        var $this = $(this);
        var target = $this.data('target');
        if (target) {
            $(".m-menu--header > div").removeClass('active');
            $this.addClass('active');
            $('.m-menu--list li').addClass('d-none');
            $(target).removeClass('d-none');

            $('.second-layer').addClass('d-none');
            $(target).find('div.m-menu--item').removeClass('d-none');
        }
    });

    $(".m-menu--item:not(.no-subs)").click(function() {
        var $this = $(this);
        $this.next('.second-layer').removeClass('d-none');
        $("div.m-menu--item").addClass('d-none');
    });

    $(".second-layer--title").click(function() {
        $('.second-layer').addClass('d-none');
        $("div.m-menu--item").removeClass('d-none');
    });

    var menuMobileBestSellerSwiper;

    $(".m-hero-menu").bind("transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd", function(){
        if ($(".m-hero-menu").hasClass('show')) {
            $('.m-menu_best-seller__container').removeClass('d-none');
            if (!menuMobileBestSellerSwiper) {
                menuMobileBestSellerSwiper = new Swiper ('.m-menu_best-seller__container', {
                    // Optional parameters
                    slidesPerView: 2.8,
                    spaceBetween: 10,
                    loop: false,
                    nested: false
                });
            }
        }
    });
}
function FaqToggleItem(){
    $('.faq--question').click(function(){
        $(this).children('.toggle').toggleClass('collapsed');
    });

    var hash = window.top.location.hash;
    if (hash) {
        var faqButton = $('.faq--section ' + hash + ' button');
        if (faqButton.length > 0 && $(hash).length > 0) {
            faqButton.click();
            $('html, body').animate({
                scrollTop: $(hash).offset().top - 80
            }, 500);
        }
    }

}
function shoppingBag() {

    $('.shopping-cart').click(function(){
        // console.log("open bag");
        checkResize();
        $('.cart--overlay').addClass('active');
        $('.cart').addClass('active');
        $('body').addClass('no-scroll');
    });
    $('.js-shopping-leave, .cart--overlay').click(function(){
        $('.cart--overlay').removeClass('active');
        $('.cart').removeClass('active');
        $('body').removeClass('no-scroll');
    });

    $('#cart--discount-btn').click(function() {
        $('#cart--discount-btn').remove();
        $('#dcodeInput').focus();
    });

    // var cartH = $('.cart').outerHeight();
    // var cartBodyH = cartH - $('.cart--header').outerHeight();
    // var cartFooterH = $('.js-cart-info ').outerHeight() + $('.cart--paynow').outerHeight() - 20 ;
    // // console.log ($('.cart--paynow').outerHeight());
    // var cartFscH = $('.cart--fsc').outerHeight();
    // var $shopbagH = cartBodyH - cartFooterH - cartFscH;

    // $('.js-cart-bag').css('height',$shopbagH +'px');
}

function handleShopindexFilter() {
    if ($('.filter--Wrap').length > 0 ) {
        $('.filter__item--lbl').click(function(){
            // close other
            var tmp = $('.filter__item--lbl.on').text();
            $('.filter__item--lbl.on').siblings('.filter__dropdown').slideToggle();
            $('.filter__item--lbl.on').removeClass('on');

            if ($(this).text() != tmp) {
                $(this).toggleClass('on');
                $(this).siblings('.filter__dropdown').slideToggle();
            }
        });
    };
}

function handleSmoothScroll(){
    if ($('.scroll-trigger').length > 0) {
        $('a.scroll-trigger').on('click', function(event) {
            event.preventDefault();
            var targetID = $(this).attr('href');
            var $target = $(targetID).find('.product__img');

            if ($target.length) {
                $('.product--inner').animate({
                    scrollTop: $target.offset().top - $('.product--inner').offset().top + $('.product--inner').scrollTop()
                });
            } else {
                $('html, body').animate({
                    scrollTop: $(targetID).offset().top - 100
                });
            }
        });
    }
}

function ProductDetailsHandleSectionH(){
    if ($('.thumnails--container').length > 0) {
        if (ww >= 992){
            // handle unfixed side bar
            var productW = $('.js-productInfo_h').width();
            var productH = $('.product--inner').outerHeight();
            var reviewTop = $('.productInfo--wrap').outerHeight();
            var unStick =  productH - reviewTop;

            $('.productInfo--wrap').css('width', productW + 'px');
            if (productH >= reviewTop) {
                $('.productInfo').css('height', productH + 'px');
            } else {
                $('.productInfo').css('height', 'auto');
            }

            var $overAllH = reviewTop + $('.productInfo--wrap').offset().top;
            var scrollT = $(window).scrollTop();

            $('.productInfo--wrap').toggleClass('fixed', ws >= 0 && ws <= unStick && productH >= reviewTop);
            $('.productInfo--wrap').toggleClass('unfixed', ws >= unStick && productH >= reviewTop);

            // thumnails
            var $thumH = $('.thumnails--container').outerHeight() - 5;
            var $offset = reviewTop - $('.product--inner').offset().top ;
            var prodImgH = $('.product--inner').outerHeight() + $('.product--inner').offset().top - 20 - 5;
            let target = document.querySelector(".product__img-container");
            let options = {
                root: null,
                rootMargin: "0px",
                threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1],
              };
            let observerCallback = (entries, observer) => {
                entries.forEach((entry) => {
                  $('.thumnails--container').toggleClass('unfixed', entry.intersectionRatio <= 0.01);
                });
              };
            let observer = new IntersectionObserver(observerCallback, options);

            observer.observe(target);
        } else {
            $('.productInfo--wrap').css('width','auto');
            $('.productInfo').css('height', 'auto');
            $('.productInfo--wrap').removeClass('fixed');
            $('.productInfo--wrap').removeClass('unfixed');
        }
    }

    $('.review__btn .btn-review').click(function(){
        $('.review__writeWrap').slideDown();

    });

    if ($('.review--overall').length > 0){
        $('.review__btn .btn-review').click(function(){
            $('.review__writeWrap').slideDown();
            $('.review__writeWrap').siblings().slideUp();
            return false;
        });
        $('.review__btn .btn-question').click(function(){
            $('.review__questionWrap').slideDown();
            $('.review__questionWrap').siblings().slideUp();
            return false;
        });
    }

}

function giftCardDropdown(){
    // if($('.dropdown--item').length > 0 ){
    //  $('.dropdown--item').click(function(){
    //      $('.dropdown--wrapper').toggleClass('active');
    //  });
    //  $('.js-opt').click(function(){
    //      // var $price = $(this).attr('data-price');
    //      // var $stock = $(this).find('.stock').attr('data-stock');
    //      // $('.dropdown--item').find('span.price').text($price);
    //      // $('.dropdown--item').find('span.stock').text($stock);
    //      $('.dropdown--wrapper').removeClass('active');
    //
    //      // if($(this).hasClass('out-of-stock')){
    //      //  $('button.btn.buynow').addClass('disable');
    //      // }else {
    //      //  $('button.btn.buynow').removeClass('disable');
    //      // }
    //
    //      var optionIndex = $(this).data('index');
    //      if (optionIndex) {
    //          $('.js-opt[data-index="'+optionIndex+'"]').removeClass('selected');
    //          $(this).addClass('selected');
    //
    //          $('.js-variantTitle.'+optionIndex).html($(this).data('value'));
    //      }
    //  });
    // }
}

function mobileSubnavFixedinAboutNAccount() {
    // mobile fixed
    if ($('.m-ContNav').length > 0 && ww <= 978){
        var $triggeerMfixed = $('.account--wrapper').offset().top - 45;
        $('.m-ContNav').toggleClass('fixed', ws >= $triggeerMfixed);
        if ($('.m-ContNav').hasClass('fixed')) {
            $('.account--content').css('margin-top', '110'+'px')
        }else{
            $('.account--content').css('margin-top', '50'+'px')
        }
    }
    // account page sidebar fixed
    if ($('.account').length > 0 && ww >= 978){
        var $Height = $('.js-accContWrap').outerHeight();
        var NavH = $('.nav').outerHeight();
        var contentH = $('.js-accContWrap').offset().top - NavH - 20;
        var $nofixed = $('.jsContentInner').outerHeight() - $('.js-accContWrap').offset().top;
        var $leftH = $('.pageInnerNav').outerHeight();
        $('.js-accContWrap').css('min-height', $leftH + "px");
        $('.js-accNavWrapper').css('height',$Height + 'px');
        $('.pageInnerNav').toggleClass('fixed', ws > 0 && ws >= contentH);
        $('.pageInnerNav').toggleClass('unfixed', ws >= $nofixed );
    }
    // about page sidebar fixed
    if ($('.about').length > 0 && ww >= 978) {
        // $('.pageInnerNav').removeClass('unfixed');
        var $Height = $('.js-accContWrap').outerHeight();
        var NavH = $('.nav').outerHeight();
        var bannerH = $('.about--banner').outerHeight();
        var overH = bannerH + NavH  ;
        var $nofixed = $('.jsContentInner').outerHeight() + 80;
        var $leftH = $('.pageInnerNav').outerHeight();
        $('.js-accContWrap').css('min-height', $leftH + "px");
        $('.js-accNavWrapper').css('height',$Height + 'px');
        $('.pageInnerNav').toggleClass('fixed', ws >= overH);
        $('.pageInnerNav').toggleClass('unfixed', ws >= $nofixed);
    }
}

function rotateLogoAbout(){
    if ($('#LogoPinkAnimate').length > 0) {
        let $spinner = $('#LogoPinkAnimate');

        addEventListener("mousemove", function(event) {
            let $spinner = $('#LogoPinkAnimate');
            var offset = $spinner.offset();
            var center_x = (offset.left) + ($spinner.width() / 2);
            var center_y = (offset.top) + ($spinner.height() / 2);
            var mouse_x = event.pageX;
            var mouse_y = event.pageY;
            var radians = Math.atan2(mouse_x - center_x, mouse_y - center_y);
            var degree = (radians * (180 / Math.PI) * -1) + 45;
            $spinner.css('-moz-transform', 'rotate(' + degree + 'deg)');
            $spinner.css('-webkit-transform', 'rotate(' + degree + 'deg)');
            $spinner.css('-o-transform', 'rotate(' + degree + 'deg)');
            $spinner.css('-ms-transform', 'rotate(' + degree + 'deg)');
        });

    }
}
function AboutAddressCheckbox(){
    // if($('.account--addressEdit').length > 0){
    //  $('.account--addressEdit label').click(function(){
    //      $('.address_default_address_2941953278034').addClass(on);
    //  });
    // }
}
function FaqCollapse(){
    if ($('.faq--section').length > 0){
        $('.collapse').on('show.bs.collapse', function () {
            var $collapse = $(this);
            var id = '#'+$collapse.attr('id');
            var $wrapper = $('.faq--question[data-target="'+id+'"]');
            var $button = $wrapper.find('.toggle');
            $button.removeClass('collapsed');
        });
        $('.collapse').on('hide.bs.collapse', function () {
            var $collapse = $(this);
            var id = '#'+$collapse.attr('id');
            var $wrapper = $('.faq--question[data-target="'+id+'"]');
            var $button = $wrapper.find('.toggle');
            $button.addClass('collapsed');
        });
    }
}

function productVariantChange() {
    if ($('.productInfo').length > 0 ) {
        $('.productInfo--materials').on('click', function() {
            $(this).toggleClass('on');
            $(this).siblings('.filter__dropdown').slideToggle();
        });

        // $('.tabs__title').on('click', function(){
        //  $(this).toggleClass('on');
        // });

        $('.filter__dropdown--opt').on('click', function() {
            var $price = $(this).attr('data-target');
            // $('.productInfo--materials').find('h5 span.smalllbl').text($price);


            if ($(this).hasClass('opt-option1')) {
                $('.opt-option1.selected').removeClass('selected');
                  $(this).addClass('selected');
                // $('.productInfo--materials').trigger('click');
                $(this).parent().parent().find('.productInfo--materials').trigger('click');
                return ;
            }

            if ($(this).hasClass('opt-option2')) {
                $('.opt-option2.selected').removeClass('selected');
                $(this).addClass('selected');
                // $('.productInfo--materials').trigger('click');
                $(this).parent().parent().find('.productInfo--materials').trigger('click');
                return ;
            }

            if ($(this).hasClass('opt-option3')) {
                $('.opt-option3.selected').removeClass('selected');
                $(this).addClass('selected');
                // $('.productInfo--materials').trigger('click');
                $(this).parent().parent().find('.productInfo--materials').trigger('click');
                return ;
            }

        });

        $('.productInfo--materials-wrapper__price .js-opt').on('click', function() {
            $('.productInfo--materials-wrapper__price .js-opt').removeClass('selected');
            $(this).addClass('selected');

        });
    }
}

function engraveOption(){
    if ($('.productInfo').length > 0 ) {
        $('.engraveOpt').on('click', function() {
            $('.engraveOpt-wrap').removeClass('on');
            $(this).find('.engraveOpt-wrap').addClass('on');
            $(this).find('input[type=radio]').attr('checked', true);
        });
    };
}

function productPageResize() {
    if ($('.js-product-page').length > 0) {
        if(ww >= 992) {
            $('.js-product-page').removeClass('m-product').addClass('product');
        } else {
            $('.js-product-page').addClass('m-product').removeClass('product');
        }
    }
}

function initTopbar () {
    const topbarEl = $('.topbar');
    const mobileRotate = $('.topbar').hasClass('mobile-carousel-rotate');
    if (topbarEl.length > 0) {
        if (mobileRotate) {
            if (window.innerWidth < 992) {
                new Swiper('.mobile-carousel-rotate', {
                    loop: true,
                    slidesPerView: 1,
                    initialSlide: 1,
                    autoplay: {
                        delay: 3000
                    },
                    speed: 800
                });
            }
        } else if (window.innerWidth < 992) {
            $('.topbar .swiper-slide:not(.active)').removeClass('d-flex').addClass('d-none');
        }
        startCountdown();
    }
}

function startCountdown() {
    const topbarEl = $('.topbar');
    const cdEl = $('.topbar-countdown');
    if (cdEl.length > 0) {
        const runCountdown = (position, text, endTime) => {
            topbarEl.addClass(`has-countdown countdown-${position}`);
            topbarEl.removeClass('d-flex');
            const wrapper = topbarEl.find('.swiper-wrapper');
            wrapper.removeClass('d-lg-flex').addClass('d-none');
            cdEl.find('.text').text(text);
            const positions = {
                left: 'start',
                right: 'end',
                middle: 'center'
            }
            cdEl.removeClass('d-none').addClass(`topbar-content-${position} align-items-${positions[position]} d-lg-flex px-4`);
            function setTime() {
                now = new Date().getTime();
                const remaining = Math.floor((endTime - now) / 1000);
                const d = (Math.floor(remaining / 3600 / 24)).toString().padStart(2, '0');
                const h = (Math.floor(remaining % (60 * 60 * 24) / (60 * 60))).toString().padStart(2, '0');
                const m = (Math.floor((remaining % 3600) / 60)).toString().padStart(2, '0');
                const s = (remaining % 60).toString().padStart(2, '0');
                cdEl.find('.time').html(`${d}D : ${h}H : ${m}M : ${s}S`);
                if (d <= 50) {
                    if (remaining > 0) {
                        setTimeout(() => {
                            setTime();
                        }, 1000);
                    } else {
                        topbarEl.removeClass(`countdown-${position}`);
                        wrapper.removeClass('d-none').addClass('d-lg-flex');
                        cdEl.addClass('d-none');
                        startCountdown();
                    }
                } else {
                    $(document).find('.has-countdown').removeClass('countdown-right');
                    $(document).find('.has-countdown').removeClass('has-countdown');
                    wrapper.removeClass('d-none').addClass('d-lg-flex');
                    cdEl.addClass('d-none');
                }
            }
            setTime();
        }

        for (let i = 0; i < window.countdownSettings.length; i++) {
            const setting = window.countdownSettings[i];
            if (!setting.enable) continue;
            const startTime = new Date(setting.startTime).getTime();
            const endTime = new Date(setting.endTime).getTime();
            let now = new Date().getTime();

            if (startTime <= now && now < endTime) {
                runCountdown(setting.position, setting.text, endTime);
                break;
            }
        }
    }
}

$('.subscribe-menu').on('click', function() {
    console.log('click');
    $('.m-menu-wrapper').click();
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', 'SmH8ne']);
});

document.querySelector('.footer__dropbtn')?.addEventListener('click', function () {
    document.querySelector('#footerDropdown')?.classList.add('show');
});

$(document).on('click', function (event) {
    if (!$(event.target).closest('.dropdown').length) {
      document.querySelector('#footerDropdown')?.classList.remove('show');
    }
});

$(document).on('click', '.dropdown li', (e) => {
    const el = $(e.target).closest('a').get(0);
    const selectedCurrency = $(el).data('currency');
    $('#localizationBottom').val(selectedCurrency);
    setCookie('manualUpdate', 'true', 360);
    $('#localization-bottom').submit();
});

const addXMLRequestCallbacks = function (callback) {
	let oldSend; let i;
	if (XMLHttpRequest.callbacks) {
		XMLHttpRequest.callbacks.push(callback);
	} else {
		XMLHttpRequest.callbacks = [callback];
		oldSend = XMLHttpRequest.prototype.send;
		XMLHttpRequest.prototype.send = function (...args) {
			for (i = 0; i < XMLHttpRequest.callbacks.length; i += 1) {
				XMLHttpRequest.callbacks[i](this, args);
			}
			oldSend.apply(this, args);
		};
	}
};


addXMLRequestCallbacks(function (xhr, args) {

    if (xhr._url.includes('a.klaviyo.com/client/subscriptions') && xhr._method === 'POST') {
        xhr.onloadend = function(event) {
            if (event.currentTarget.readyState === 4) {
                $('.klaviyo-close-form').click();
            }
        }
    }
});
